import { constants } from "../constants";

const FALLBACK_FLAGS = {
  "reg_evo_only_mode_enabled": false
};

/**
 * Fetches feature flags from the config API.
 * Returns an object mapping flag keys to boolean values.
 * On failure, returns FALLBACK_FLAGS (feature off — preserve existing behavior).
 */
export const fetchFeatureFlags = async () => {
  try {
    const res = await fetch(
      `${constants.REACT_APP_PROPEL_SERVICE_URL}/api/config?domain=feature-flags`
    );

    if (!res.ok) {
      return FALLBACK_FLAGS;
    }

    const data = await res.json();
    const items = data?.config?.["feature-flags"] ?? [];

    const flags = {};
    for (const item of items) {
      if (item.value_type === "boolean") {
        flags[item.key] = item.value === "true";
      }
    }
    return flags;
  } catch {
    return FALLBACK_FLAGS;
  }
};
